import React from 'react';
import { useNavigate } from 'react-router';
import moment from 'moment';

const SubscriptionCard = ({ doctor, className = "" }) => {
    const navigate = useNavigate();

    if (!doctor) return null;

    const endDate = moment(doctor.subscription_end_date);
    const today = moment();
    const daysRemaining = endDate.diff(today, 'days');
    
    // Status Logic
    const isExpired = daysRemaining < 0;
    const isTrial = doctor.subscription_status === 'trial'; // ট্রায়াল চেক

    // Dynamic Styles
    let cardStyle = "bg-green-50 border-green-200 text-green-900";
    let badgeStyle = "bg-green-100 text-green-700";
    let statusText = "Active";

    if (isExpired) {
        cardStyle = "bg-red-50 border-red-200 text-red-900";
        badgeStyle = "bg-red-100 text-red-700";
        statusText = "Expired";
    } else if (isTrial && !isExpired) {
        // ট্রায়াল মোড স্টাইল (নীল রঙ)
        cardStyle = "bg-blue-50 border-blue-200 text-blue-900";
        badgeStyle = "bg-blue-100 text-blue-700";
        statusText = "Free Trial";
    } else if (daysRemaining < 10) {
        cardStyle = "bg-yellow-50 border-yellow-200 text-yellow-900";
        badgeStyle = "bg-yellow-100 text-yellow-700";
        statusText = "Expiring Soon";
    }

    const handleRenew = () => {
        navigate('/subscription');
    };

    return (
        <div className={`border rounded-xl p-5 shadow-sm ${cardStyle} ${className}`}>
            <div className="flex justify-between items-start mb-3">
                <div>
                    <h3 className="font-bold text-lg">Subscription Plan</h3>
                    <p className="text-sm opacity-80 capitalize">
                        {isTrial ? 'Trial (1 Month)' : `${doctor.plan_type || 'Basic'} Plan`}
                    </p>
                </div>
                <span className={`px-2 py-1 rounded text-xs font-semibold ${badgeStyle}`}>
                    {statusText}
                </span>
            </div>

            <div className="mb-4">
                <p className="text-sm font-medium">Valid Until:</p>
                <p className="text-xl font-bold">
                    {doctor.subscription_end_date 
                        ? moment(doctor.subscription_end_date).format('DD MMM, YYYY') 
                        : 'N/A'}
                </p>
                {!isExpired && (
                    <p className="text-xs mt-1 opacity-75">
                        {daysRemaining} days remaining in trial
                    </p>
                )}
            </div>

            {/* ট্রায়াল মোডেও আপগ্রেড বাটন দেখানো ভালো */}
            <button 
                onClick={handleRenew}
                className={`w-full py-2 px-4 rounded-lg text-white font-medium transition-colors shadow-sm
                    ${isExpired ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'}
                `}
            >
                {isExpired ? 'Renew Membership' : 'Upgrade to Premium'}
            </button>
        </div>
    );
};

export default SubscriptionCard;